import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

export function InfoTooltip({
  message,
  placement = "top",
  size = "small",
  color_required = false
}) {
  return (
    <Tooltip title={message} placement={placement} arrow>
      <IconButton size={size} style={{ padding: size === "small" ? 4 : 8 }}>
        {color_required ? (
          <InfoOutlinedIcon
            color="inherit"
            fontSize={size === "small" ? "small" : "default"}
            style={{
              backgroundColor: "#0091ff",
              borderRadius: "50%",
              color: "#fff"
            }}
          />
        ) : (
          <InfoOutlinedIcon
            fontSize={size === "small" ? "small" : "default"}
          />
        )}
      </IconButton>
    </Tooltip>
  );
}
